// ls
import { ls } from 'qiao.ls.js';

// constants
import { constants } from './_constants.js';

/**
 * getUserinfoFromLocalStorage
 * @returns
 */
export const getUserinfoFromLocalStorage = () => {
  return ls(constants.userinfo);
};

/**
 * setUserinfoToLocalStorage
 * @param {*} userinfo
 * @returns
 */
export const setUserinfoToLocalStorage = (userinfo) => {
  window.localStorage.setItem('__userinfo_token__', userinfo);
  return ls(constants.userinfo, userinfo);
};

/**
 * clearUserinfoToLocalStorage
 * @returns
 */
export const clearUserinfoToLocalStorage = () => {
  return ls(constants.userinfo, null);
};
